import { FormGroup } from 'components/form/FormGroup';
import { FormInput } from 'components/form/FormInput';
import { FormSection } from 'components/form/FormSection';
import { classNames, useEffect, useState } from 'libs/react';
import { React } from 'libs/react';
import { FormPhone } from 'components/form/FormPhone';
import { FormField } from 'components/form/FormField';
import { FormGoogleAutocompleteInput } from 'components/form/FormGoogleAutocompleteInput';
import { FormSelect } from 'components/form/FormSelect';
import { Provinces } from 'components/form/data/Provinces';
import { Countries } from 'components/form/data/Countries';
import { FormClientSelect } from 'modules/client/forms/FormClientSelect';
import { FormDate } from 'components/form/FormDate';
import { StoreGiftFields } from './StoreGiftFields';
import { StoreBackButton } from './components/StoreBackButton';
import './StoreContact.scss';
/**
 * @component ContactSection
 * @since 1.0.0
 */
export function ContactSection(props) {
    var _a, _b, _c;
    const { contactFields, orderEmail, addressError, showPlannedDate, hidePartnerField } = props;
    const [autocompleteData, setAutocompleteData] = useState({
        civicNumber: '',
        road: '',
        apartment: '',
        city: '',
        province: '',
        postalcode: '',
        country: '',
        latitude: null,
        longitude: null
    });
    const [address, setAddress] = useState('');
    const queryParameters = new URLSearchParams(window.location.search);
    const partner = (_a = queryParameters.get('partner')) === null || _a === void 0 ? void 0 : _a.toLowerCase();
    const showAddressField = contactFields === null || contactFields === void 0 ? void 0 : contactFields.includes('ADDRESS');
    /**
     * @function onLocationSelected
     * @since 1.0.0
     * @hidden
     */
    const onLocationSelected = (location) => {
        setAutocompleteData({
            civicNumber: location.civicNumber,
            road: location.road,
            apartment: location.apartment,
            city: location.city,
            province: location.province,
            postalcode: location.postalcode,
            country: location.country,
            latitude: location.latitude,
            longitude: location.longitude
        });
        const formattedAddress = location.civicNumber +
            ' ' +
            location.road +
            ' ' +
            location.apartment +
            ', ' +
            location.city +
            ', ' +
            location.province +
            ', ' +
            location.postalcode +
            ' ' +
            location.country;
        setAddress(formattedAddress);
    };
    useEffect(() => {
        if (autocompleteData.civicNumber)
            props.onAddressFilled(true);
    }, [autocompleteData]);
    const className = classNames('section contact-section');
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "contact-section-contact" },
            React.createElement(FormSection, { title: props.onBack ? (React.createElement("span", { className: "contact-section-title" },
                    React.createElement(StoreBackButton, { onPress: props.onBack }),
                    t('Contact information'))) : (t('Contact information')) },
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { label: t('First name'), name: "firstName", required: true, pattern: '^(?!\\s*$).+', placeholder: t('Enter your first name…') })),
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { label: t('Last name'), name: "lastName", required: true, pattern: '^(?!\\s*$).+', placeholder: t('Enter your last name…') }))),
                React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormInput, { label: t('Email'), name: "email", type: "email", required: true, value: orderEmail, pattern: '^(?!\\s*$).+', placeholder: t('Enter your email address…') })),
                    React.createElement(FormField, null,
                        React.createElement(FormPhone, { label: t('Phone'), name: "phone", placeholder: t('Enter your phone number…') }))),
                React.createElement(FormGroup, null,
                    (contactFields === null || contactFields === void 0 ? void 0 : contactFields.includes('CLIENT')) && (React.createElement(FormField, null,
                        React.createElement(FormInput, { type: "text", name: "name", label: t('Enterprise'), placeholder: t('Enter enterprise name…') }))),
                    showAddressField && (React.createElement(FormField, null,
                        React.createElement("div", { id: "store-address-field" },
                            React.createElement(FormGoogleAutocompleteInput, { name: "autocomplete", label: t('Address'), placeholder: t('Enter address…'), onLocationSelected: onLocationSelected, value: address, required: true }),
                            addressError && (React.createElement("p", { className: "contact-section__address-error", role: "alert", "aria-live": "polite" }, t('Please enter your address to continue.')))))),
                    (contactFields === null || contactFields === void 0 ? void 0 : contactFields.includes('PARTNERS')) && !hidePartnerField && (React.createElement(FormField, null,
                        React.createElement(FormClientSelect, { name: "partner", label: t('Store'), isEndClient: false, placeholder: t('Select store'), filter: { number: partner }, required: true })))),
                showPlannedDate && (React.createElement(FormGroup, null,
                    React.createElement(FormField, null,
                        React.createElement(FormDate, { name: "plannedDate", label: t('Desired date'), time: false, required: true })))),
                React.createElement(StoreGiftFields, null),
                (contactFields === null || contactFields === void 0 ? void 0 : contactFields.includes('ADDRESS')) && (React.createElement(React.Fragment, null,
                    React.createElement(FormGroup, { className: "address-section__hidden", "aria-hidden": "true" },
                        React.createElement(FormField, null,
                            React.createElement(FormInput, { type: "text", name: "civicNumber", label: t('Civic Number'), placeholder: t('Enter civic number'), value: autocompleteData.civicNumber })),
                        React.createElement(FormField, null,
                            React.createElement(FormInput, { type: "text", name: "road", label: t('Street'), placeholder: t('Enter street'), value: autocompleteData.road })),
                        React.createElement(FormField, null,
                            React.createElement(FormInput, { type: "text", name: "apartment", label: t('App. / Suite / Office #'), placeholder: t('Enter App. / Suite / Office #'), optional: true, value: autocompleteData.apartment })),
                        React.createElement(FormField, null,
                            React.createElement(FormInput, { type: "text", name: "city", label: t('City'), placeholder: t('Enter City'), value: autocompleteData.city })),
                        React.createElement(FormField, null,
                            React.createElement(FormSelect, { name: "province", label: t('Province/State'), value: autocompleteData.province, placeholder: t('Select Province'), options: Provinces })),
                        React.createElement(FormField, null,
                            React.createElement(FormInput, { type: "text", name: "postalcode", label: t('Postal Code'), placeholder: t('Enter Postal Code'), value: autocompleteData.postalcode })),
                        React.createElement(FormField, null,
                            React.createElement(FormSelect, { name: "country", label: t('Country'), placeholder: t('Enter Country'), options: Countries, value: autocompleteData.country })),
                        React.createElement(FormField, null,
                            React.createElement(FormInput, { type: "hidden", name: "latitude", label: t('Latitude'), placeholder: t('Enter latitude'), step: "0.000001", min: "-90", max: "90", optional: true, value: (_b = autocompleteData.latitude) === null || _b === void 0 ? void 0 : _b.toFixed(6) }))),
                    React.createElement(FormGroup, { className: "address-section__hidden", "aria-hidden": "true" },
                        React.createElement(FormField, { ratio: 6 },
                            React.createElement(FormInput, { type: "hidden", name: "longitude", label: t('Longitude'), placeholder: t('Enter longitude'), step: "0.000001", min: "-180", max: "180", optional: true, value: (_c = autocompleteData.longitude) === null || _c === void 0 ? void 0 : _c.toFixed(6) })))))))));
}
